// extracted by mini-css-extract-plugin
export default {"col":"Video_col__CxZ74","col_video":"Video_col_video__MTMqe","img":"Video_img__LYRur","div":"Video_div__k8ZwK"};